import styled, { css } from 'styled-components';

import CustomScrollbars from '../../common/CustomScrollbar';

import bg from '../../assets/images/background.svg';


export const Wrapper = styled.div`
  position: relative;
  background-image: url('${bg}');
  background-position: center;
  background-size: cover;
  background-color: #1a1a1a;
  border-radius: 6px;
  padding: 20px 20px;

  ${props => props.hidePatternBg && css`
    background-image: none;
  `};

  h2.title {
    text-transform: uppercase;
    font-size: 26px;
    font-weight: 900;
    font-style: italic;
    color: white;
    margin-top: -35px;
    margin-bottom: 20px;
  }

  h3 {
    font-weight: bold;
    font-style: italic;
    color: #fff;
    font-size: 20px;
    margin: 0;
  }

  h4 {
    font-size: 26px;
    color: #3ee9f7;
    font-style: italic;
  }

  h5 {
    font-size: 22px;
    font-weight: 100;
    font-style: normal;
    color: white;

    span {
      color: #3ee9f7;
    }
  }

  .single-col {
    display: grid;
    grid-template-columns: 1fr;
  }
  @media all and (max-width: 768px) {
    padding: 20px 10px;
  }
`;

export const Title = styled.h2`
  text-transform: uppercase;
  font-size: 26px;
  font-weight: 900;
  font-style: italic;
  color: white;
  margin-top: -39px;
  margin-bottom: 35px;
  line-height: unset;

  span {
    color: #ff0033;
  }
  @media all and (max-width: 1024px) {
    font-size: 22px;
  }
`;

export const ScrollButton = styled.div`
  position: absolute;
  right: 15px;

  ${props => props.direction === 'up' && css`
    top: 15px;
  `};

  ${props => props.direction === 'down' && css`
    bottom: 15px;
  `};

  button, button:active, button:focus, button:hover {
    outline: none;
    cursor: pointer;
    background-color: #ff0033;
    border-radius: 50%;
    height: 30px;
    width: 30px;

    i {
      color: #ff0033;
    }
  }
`;

export const StyledScrollbars = styled(CustomScrollbars)`
  margin: 0 0 30px 0;
  height: 600px

  & > div:nth-of-type(1) {
    overflow: hidden !important;
    width: calc(100% - 8px);
  }

  & > div:nth-of-type(2) {
    display: none;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Card/Card.styles.ts